import ClosureSurvey from 'sprockets_react/closure_survey/registry'
import { EventEmitter } from 'events'

ClosureSurvey.StepSequence = {

  defaultSequence() {
    const wizard = ClosureSurvey
    const steps = [
      wizard.HasJobBeenDoneYet,
      wizard.WhoDidTheJob,
      wizard.RateExperience,
      wizard.HowMuchDidYouPay,
      wizard.SubmitFeedback,
      wizard.JobStatusUpdated
    ]

    return steps
  },

  removeStep(position) {
    let currentSteps = ClosureSurvey.Steps
    ClosureSurvey.Steps = [...currentSteps.slice(0, position), ...currentSteps.slice(position + 1)]
  },

  removeStepByType(stepType) {
    let position = ClosureSurvey.Steps.indexOf(stepType)

    if (position === -1) { return }

    this.removeStep(position)
  },

  init() {
    ClosureSurvey.Emitter = ClosureSurvey.Emitter || new EventEmitter()
    ClosureSurvey.Steps = ClosureSurvey.StepSequence.defaultSequence()
  }
}
